import { EntityType } from '@communities/content-management/domain';

/**
 * Helper function to check if entity type is community
 */
export function isCommunity(entityType: EntityType): boolean {
  return entityType === EntityType.COMMUNITY;
}
